import { cloneDeep, get, last } from "lodash";

const removeItemByPath = (tree, path = []) => {
  const cloned = cloneDeep(tree);

  // The parent path is everything except the last segment
  const parentPath = path.slice(0, -1);
  const removeIndex = last(path);

  // If there's no parent path => we're removing from the top;
  if (!parentPath.length) {
    cloned.splice(removeIndex, 1);

    return cloned;
  }

  // Get the parent array
  const parent = get(cloned, parentPath);

  if (Array.isArray(parent)) {
    parent.splice(removeIndex, 1);
  }

  return cloned;
};

export default removeItemByPath;
